module.exports = __webpack_public_path__ + "img/foodcourt-banner-h5-clean.8cff31df.png";